module.exports = "<div class=\"single-content\">\n\n</div>\n";